import { defineModal, Modal } from '@libs/ui/ds'
import { useCounterModulationTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import React from 'react'

import ContentModal from './contentModal'

type ModalTooltipProps = {
  keyTooltip: string
}

export const modalTooltipDef = defineModal<ModalTooltipProps>({
  name: 'modalTooltip'
})

const ModalTooltip: FC = () => {
  const { close, isOpen, data } = modalTooltipDef.useModal()
  const { t } = useCounterModulationTranslation()

  return (
    <Modal variant='right' opened={isOpen} onClose={close}>
      <Modal.Header title={t('counterModulation.index.modulation')} />

      <Modal.Content>
        {/* @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333) */}
        <ContentModal keyTooltip={data.keyTooltip} />
      </Modal.Content>
    </Modal>
  )
}

export default modalTooltipDef.withModalShow(ModalTooltip)
